import MultiSelectDropdown, { Option } from '../components/MultiSelectDropdown';
import { useRecoilState, useRecoilValue } from 'recoil';
import { filterCountriesAtom, filterIndustriesAtom, filterListsAtom } from '../store/filters';
import { convertToValueLabelStrings, convertToValueLabelListIds } from '../utils/compare-functions';
import { IUserListRef } from '../types/company';
import { userListsAtom } from '../store/portfolio';

export default function CompareFilters({
  industries,
  countries,
  hideList,
}: Readonly<{
  industries: string[];
  countries: string[];
  hideList: boolean;
}>) {
  const [filterCountries, setFilterCountries] = useRecoilState(filterCountriesAtom);
  const [filterIndustries, setFilterIndustries] = useRecoilState(filterIndustriesAtom);
  const [filterLists, setFilterLists] = useRecoilState(filterListsAtom);

  const userLists = useRecoilValue<IUserListRef[]>(userListsAtom);

  const resetFilters = () => {
    setFilterCountries([]);
    setFilterIndustries([]);
    if (!hideList) setFilterLists([]);
  };

  const countryOptions: Option<string>[] = countries.map((c) => ({ value: c, label: c }));
  const industryOptions: Option<string>[] = industries.map((i) => ({ value: i, label: i }));
  const listOptions: Option<number>[] = userLists.map((list) => ({ value: list.id, label: list.name ?? `List ${list.id}` }));

  return (
    <div className="flex items-start">
      <div className="mr-2 font-bold my-[9px]">Filter by:</div>

      <div>
        <MultiSelectDropdown<string>
          width="auto"
          options={countryOptions}
          selectedOptions={convertToValueLabelStrings(filterCountries)}
          onSelectionChange={setFilterCountries}
          placeHolder="Regions"
        />
      </div>

      <div className="fss-button-spacer"></div>

      {!hideList && (
        <div className="flex items-center">
          <div className="hidden xl:inline">
            <MultiSelectDropdown<number>
              width="auto"
              options={listOptions}
              selectedOptions={convertToValueLabelListIds(filterLists, userLists)}
              onSelectionChange={setFilterLists}
              placeHolder="Lists"
            />
          </div>
        </div>
      )}

      {!hideList && <div className="fss-button-spacer hidden xl:inline"></div>}

      <div className="hidden lg:inline">
        <MultiSelectDropdown<string>
          width="auto"
          options={industryOptions}
          selectedOptions={convertToValueLabelStrings(filterIndustries)}
          onSelectionChange={setFilterIndustries}
          placeHolder="Industries"
        />
      </div>

      <div className="fss-button-spacer"></div>

      <div className="flex items-center">
        <button onClick={resetFilters} className="fss-chart-button" title="Reset filters">
          <img src="/icons/reset.svg" alt="Reset filters" />
          <div>Reset filters</div>
        </button>
      </div>
    </div>
  );
}
